export default __webpack_public_path__ + "static/media/banner_rearrange.482ecf70.svg";